import { defineStyle, defineStyleConfig } from '@chakra-ui/react';
const baseStyle = defineStyle({
  color: 'white',
  background: 'linear-gradient(271.75deg, #CE4EAA 0%, #F56271 100%)',
  borderRadius: '2px',
  paddingX: 1.5
});
export const badgeTheme = defineStyleConfig({
  baseStyle
});